<script>
import { set, get, clear } from "@/common/helps/local-storage";
import { map_query } from "@/core/functions/map-path-query";
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    clientIdSSO: () => process.env.VUE_APP_SSO_CLIENT_ID || "",
    ...mapGetters("modAuth", ["getErrorSSO", "getProcessingSSO"]),
  },
  created() {
    let is_alternative = false;
    setInterval(() => {
      const app = document.getElementById("login");
      if (app) {
        if (is_alternative) {
          is_alternative = false;
          return app.classList.add("login-alternative-img");
        }

        is_alternative = true;
        return app.classList.remove("login-alternative-img");
      }
    }, 10000);
  },
  beforeMount() {
    this.validSession();
  },
  methods: {
    ...mapActions("modAuth", ["authWithSSOAction"]),
    login() {
      const state = this.randomSTR();
      set("token_sso", state);
      const params = {
        client_id: this.clientIdSSO,
        response_type: "code",
        redirect_uri: window.location.origin.concat("/auth/callback"),
        scope: "openid",
        state,
      };
      const SSOPath = process.env.VUE_APP_SSO_URL || "";
      window.location = SSOPath.concat("/oauth/authorize", map_query(params));
    },
    validSession() {
      const code = this.$route.query.code || null;
      const state = this.$route.query.state;
      if (code && state === get("token_sso")) {
        const params = { code };
        this.authWithSSOAction({ params });
      } else {
        clear();
      }
    },
  },
};
</script>

<template>
  <div class="login" id="login">
    <div class="custom-container">
      <b-row cols="4" class="pt-5">
        <b-col cols="12" md="5">
          <b-card class="mb-2">
            <b-container class="pt-4">
              <b-card-title>
                <b-img
                  :src="
                    require('@/assets/images/login/Logo_Virtual_Partner.svg')
                  "
                  fluid
                  alt="logo-vp"
                />
              </b-card-title>

              <p class="pt-4 login-title">¡Bienvenido a tu Virtual Partner!</p>
              <p class="login-sub-title">
                Para abrir o gestionar solicitudes inicia sesión
              </p>

              <b-card-text class="text-center"> </b-card-text>

              <button
                class="cta login-btn"
                :disabled="getProcessingSSO"
                @click.prevent="login"
              >
                <b-spinner v-if="getProcessingSSO" />
                <span v-else>Iniciar sesión</span>
              </button>
              <p v-if="getErrorSSO.exist">
                <small class="alert-danger">
                  {{ getErrorSSO.msg }}
                </small>
              </p>
            </b-container>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card {
  box-shadow: none !important;
  border-radius: 24px !important;
}
.custom-container {
  max-width: 100%;
  padding-right: 35px;
  padding-left: 30px;
  margin-right: auto;
  margin-left: auto;
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../../../../assets/images/login/1_login.svg");
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  transition: opacity 3s ease-in-out;
  -webkit-transition: opacity 3s ease-in-out;
  -moz-transition: opacity 3s ease-in-out;
  -o-transition: opacity 3s ease-in-out;
}

.login-alternative-img {
  background-image: url("../../../../assets/images/login/2_login.svg") !important;
}

.login-title {
  font-family: "Ubuntu", sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 26px;
  line-height: 36px;
  align-items: center;
  color: #425777;
  word-wrap: break-word;
}

.login-sub-title {
  font-family: "Ubuntu", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 28px;
  align-items: center;
  color: #607d8b;
  word-wrap: break-word;
}

.login-btn {
  color: #ffffff !important;
  background-color: #5d5fef !important;
  margin: 30px 0 !important;
  border-color: transparent !important;
  border-radius: 8px !important;
  padding: 5px 15px 5px 15px;
}

.login-btn:hover {
  opacity: 0.9;
}
</style>
